exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-title[data-v-7bb590e0]{font-size:12px;color:rgba(0,0,0,.6)}.report-data[data-v-7bb590e0]{font-size:30px;color:#000}", ""]);

// exports
